// CAR-4102: remembers which announcements a signed-in user has closed, so Dismiss survives a refresh
// (the "Refresh Browser" message asks for exactly that) and the live-connection re-fetch.
//
// Keyed per user and per announcement text, so a shared shop computer keeps each person's choice and an
// edited announcement shows again. Info is remembered until its text changes (localStorage); Critical only
// for this browser session (sessionStorage), so a live outage notice is back the next day. The last
// MAX_REMEMBERED keys are kept. Storage can be missing or throw (private mode, blocked site data): then
// Dismiss lasts until the next refresh, as before.
const STORAGE_KEY = 'broadcast-dismissed'
export const MAX_REMEMBERED = 10

const isCritical = (broadcast) => broadcast?.type === 'CRITICAL'

const storageFor = (broadcast) => {
  try {
    return isCritical(broadcast) ? window.sessionStorage : window.localStorage
  } catch {
    return null
  }
}

// Short, stable fingerprint of the text (djb2), so stored keys don't hold the whole message.
const fingerprint = (text) => {
  let hash = 5381
  for (let i = 0; i < text.length; i += 1) {
    hash = ((hash << 5) + hash + text.charCodeAt(i)) | 0
  }
  return (hash >>> 0).toString(36)
}

export const getBroadcastKey = (broadcast, userEmail) =>
  [
    (userEmail || 'anonymous').toLowerCase(),
    isCritical(broadcast) ? 'CRITICAL' : 'INFO',
    fingerprint(`${broadcast?.subject || ''}\n${broadcast?.message || ''}`)
  ].join('|')

const readKeys = (storage) => {
  try {
    const keys = JSON.parse(storage?.getItem(STORAGE_KEY) || '[]')
    return Array.isArray(keys) ? keys : []
  } catch {
    return []
  }
}

export const isBroadcastDismissed = (broadcast, userEmail) =>
  readKeys(storageFor(broadcast)).includes(getBroadcastKey(broadcast, userEmail))

export const rememberBroadcastDismissed = (broadcast, userEmail) => {
  const storage = storageFor(broadcast)
  if (!storage) return
  const key = getBroadcastKey(broadcast, userEmail)
  const keys = [key, ...readKeys(storage).filter((k) => k !== key)].slice(0, MAX_REMEMBERED)
  try {
    storage.setItem(STORAGE_KEY, JSON.stringify(keys))
  } catch {
    /* storage full or blocked: the banner just comes back after a refresh */
  }
}
